import { FiShieldOff } from "react-icons/fi";

const DecisionCard = ({
  decisionTitle,
  decisionStatus,
  combinedIncome,
  combinedEffortRate,
  decisionSummary,
  insurable,
  recommendedActions,
  children,
  currentLang,
}) => {
  // Determine the status class for styling
  const getStatusClass = () => {
    if (typeof decisionStatus === "string") {
      const lowerStatus = decisionStatus.toLowerCase();
      if (lowerStatus === "approved") return "approved";
      if (lowerStatus === "rejected") return "rejected";
      return "conditional";
    }
    return "conditional";
  };

  const statusClass = getStatusClass();

  return (
    <section className={`linked-report__decision-card ${statusClass}`}>
      <div className="linked-report__decision-title-row">
        <div className="linked-report__decision-title">{decisionTitle}</div>
        {insurable !== null && insurable !== undefined && (
          <span
            style={{
              color: insurable ? "#82CF3F" : "#FF3C3C",
              backgroundColor: insurable ? "#F2FBE9" : "#FFE2E2",
              border: insurable ? "none" : "1px solid #EB9B9C",
            }}
            className="report-overview__badge"
          >
            <>
              {insurable ? (
                <img src={"/images/shield.svg"} alt="" />
              ) : (
                <FiShieldOff
                  className="report-overview__badge-icon"
                  size={14}
                />
              )}
              {insurable ? "Insurable" : "Not Insurable"}
            </>
          </span>
        )}
      </div>
      <div className="linked-report__decision-metrics">
        <strong>{`€${Math.round(combinedIncome || 0)}/mo`}</strong>
        <span>•</span>
        <strong>{`Effort rate ${combinedEffortRate}`}</strong>
      </div>
      {decisionSummary && (
        <p className="linked-report__decision-description">
          {typeof decisionSummary === "string"
            ? decisionSummary
            : decisionSummary[currentLang]?.split("\n")?.join(" ") ||
              "This tenant nearly meets the criteria for automatic approval."}
        </p>
      )}
      {children}
    </section>
  );
};

export default DecisionCard;
